export default class BlogPostsLoadMore {

  public selector: HTMLElement;
  public posts: NodeListOf<HTMLElement> | null;
  public loadMoreBtn: HTMLElement;

  constructor(selector: HTMLElement) {
    this.selector = selector;
  }

  init() {
    // this.cache();
    // this.bindings();
  }

  cache() {
    const { selector } = this;
    this.posts = selector.querySelectorAll('.js-o-tabs__item-container');
    this.loadMoreBtn = selector.querySelector('.js-o-blog-teaser-list__load-more') as HTMLElement;
  }

  bindings() {
    if(this.loadMoreBtn) {
      this.loadMoreBtn.addEventListener('click', (e: MouseEvent) => this.loadMore(e));
    }
  }

  loadMore(e: MouseEvent) {
    const { posts } = this;
    e.preventDefault();
    let anz = 0;
    if(posts) {
      posts.forEach((post) => {
        if(anz >= 4) {
          return;
        }else if(post.classList.contains('is-hidden')) {
          post.classList.remove('is-hidden');
          anz += 1;
        }
      });

      if(!posts[posts.length - 1].classList.contains('is-hidden')) {
        this.loadMoreBtn.style.display = 'none';
      }
    }
  }
}
